import React, { useState, useEffect } from "react";
import "../../style/frontpage/css/passage.css"
import { backendGetRequest } from "../../helpers/callBackend";
import CircularProgress from '@mui/material/CircularProgress';

export default function PassageForm(props) {
    const [passageId, setPassageId] = useState('');
    const [remainingAttempts, setRemainingAttempts] = useState(20);

    const getPsgId = (delay = 3000) => {
        if (remainingAttempts <= 0) return;

        backendGetRequest("/api/user/login", {}, "loading",
        ).then((response) => {
            setPassageId(response?.data?.passage_app_id)
            setRemainingAttempts(0);
        }).catch((error) => {
            setRemainingAttempts(remainingAttempts - 1);
            setTimeout(() => { getPsgId(); }, delay);
        });
    }

    useEffect(() => {
        getPsgId();
      }, [])

    return (
        <>
            {passageId && props.loginForm ? (
                <passage-login app-id={passageId} ></passage-login>
            ) : passageId && props.registerForm ? (
                <passage-register app-id={passageId} ></passage-register>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px', width: '100%' }}>
                    <CircularProgress />
                </div>
            )}
        </>
    );
};

